export const invitationMainQueryKey = "invitations";
